export default __webpack_public_path__ + "static/media/right_arrow.c0f36dd7.svg";